import React from 'react';
import { Badge, Box, Button, ColumnLayout, Container, Header, SpaceBetween, StatusIndicator } from '@cloudscape-design/components-themed/components';
import { useNavigate } from 'react-router-dom';
import { PATH_SETTINGS } from '@/presentation/common-utils/constants';
import { getRandomUUID } from '@/lib/misc/utils';
import { useAppContext } from '@/presentation/providers/app-context-provider';
const SettingsDetails = props => {
    const { isLegacyOrg } = useAppContext();
    //Console log to avoid unused variable check for isLegacyOrg
    console.log("isLegacyOrg", isLegacyOrg);
    const navigate = useNavigate();
    const makeDomainBadges = () => {
        var _a;
        const badges = (_a = props === null || props === void 0 ? void 0 : props.allowedDomains) === null || _a === void 0 ? void 0 : _a.map(domain => {
            return (React.createElement(Badge, { key: getRandomUUID(), color: 'grey' }, domain === null || domain === void 0 ? void 0 : domain.label));
        });
        return (React.createElement(SpaceBetween, { size: 'm', direction: 'horizontal' }, badges));
    };
    const isBetaAccessEnabled = (props === null || props === void 0 ? void 0 : props.isBetaAccess)
        ? (React.createElement("span", { className: "inline-flex items-center rounded-md px-2 py-1 ml-2 text-xs font-medium rules-library-info-badge" }, "BETA ACCESS"))
        : ('');
    return (React.createElement(Container, { header: React.createElement(Header, { variant: "h2", actions: React.createElement(SpaceBetween, { direction: "horizontal", size: "xs" },
                React.createElement(Button, { variant: "primary", "ata-testid": "click-to-edit-settings", onClick: () => {
                        navigate(PATH_SETTINGS.EDIT);
                    } }, "Edit")) }, "Details") },
        React.createElement(Box, { padding: { top: "m" } },
            React.createElement(ColumnLayout, { columns: 4, variant: "text-grid" },
                React.createElement(SpaceBetween, { size: "l" },
                    React.createElement(Box, null,
                        React.createElement(Box, { variant: "awsui-key-label" }, "Organization Name"),
                        React.createElement(Box, null,
                            props.orgName,
                            " ",
                            isBetaAccessEnabled))),
                React.createElement(SpaceBetween, { size: "l" },
                    React.createElement(Box, null,
                        React.createElement(Box, { variant: "awsui-key-label" }, "Organization ID"),
                        React.createElement(Box, null, props.orgID))),
                React.createElement(SpaceBetween, { size: "l" },
                    React.createElement(Box, null,
                        React.createElement(Box, { variant: "awsui-key-label" }, "Allowed Domains"),
                        React.createElement(Box, null, makeDomainBadges()))),
                React.createElement(SpaceBetween, { size: "l" },
                    React.createElement(Box, null,
                        React.createElement(Box, { variant: "awsui-key-label" }, "Multi-Factor Authentication"),
                        React.createElement(Box, null, (props === null || props === void 0 ? void 0 : props.isMFAEnabled)
                            ? (React.createElement(StatusIndicator, { type: "success" }, "Enabled"))
                            : (React.createElement(StatusIndicator, { type: "error", colorOverride: "grey" }, "Disabled")))))))));
};
export default SettingsDetails;
